import React from 'react';

export default function SNoPage() {
    return (
        <h2>No such a page</h2>
    )
}